export default __webpack_public_path__ + "static/media/Lab_Partner_3_PCR_Product.1745e4c6.svg";